import React, { useState, useEffect, useRef } from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

import styles from './styles';

function RatioWithDateSelect(props) {
  const [value, setValue] = useState(props.initialOpen || props.initialDate ? 'optionTwo' : 'optionOne');
  const [selectedDate, setSelectedDate] = useState(props.initialDate || new Date());
  const [hasTriggeredInitialOpen, setHasTriggeredInitialOpen] = useState(
    props.initialOpen || !!props.initialDate || false
  );

  // Mirror selectedDate in a ref, updated synchronously alongside every
  // setSelectedDate. onClose/onBlur fire in the SAME tick as the value change
  // when closeOnSelect closes the picker after the minutes view — reading
  // `selectedDate` from the render closure there would be stale (the picker
  // would "lose" the just-picked minute). The ref always holds the latest.
  const selectedDateRef = useRef(props.initialDate || new Date());

  // When a saved date arrives via props after mount (e.g. quote loads
  // asynchronously), adopt it as the selected date once.
  useEffect(() => {
    if (props.initialDate) {
      setSelectedDate(props.initialDate);
      selectedDateRef.current = props.initialDate;
      setValue('optionTwo');
      setHasTriggeredInitialOpen(true);
    }
  }, [props.initialDate]);

  // Auto-open when initialOpen becomes true. The previous version only ran on
  // mount with empty deps, which missed the common case of editSettings arriving
  // asynchronously from a quote load — initialOpen is false at mount and only
  // flips true on the next render. Watch the prop and trigger once.
  useEffect(() => {
    if (props.initialOpen && !hasTriggeredInitialOpen) {
      setValue('optionTwo');
      setHasTriggeredInitialOpen(true);
      props.onChange({
        target: {
          name: props.name + "Checked",
          value: true
        }
      });
    }
  }, [props.initialOpen]);

  useEffect(() => {
    // Don't override if we set the initial open state
    if (hasTriggeredInitialOpen && props.value === true) {
      return;
    }
    // Don't reset to optionOne if initialOpen was set
    if (hasTriggeredInitialOpen && !props.value) {
      return;
    }
    setValue(props.value ? "optionTwo" : "optionOne");
  }, [props.value]);

  const handleChange = (event) => {
    console.log("RatioWithDateSelect -" + event.target.value);
    setValue(event.target.value);
    props.onChange({
      target: {
        name: props.name+"Checked",
        value: event.target.value === "optionTwo"
      }
    });
    if (event.target.value === "optionTwo") {
      // props.onChange({
      //   target: {
      //     name: props.name,
      //     value: selectedDate,
      //   }
      // });
    }
  };

 const handleDateChange = (date) => {
  // First, check if the date object exists and is valid before doing anything else.
  // This prevents the crash when the field is cleared (date becomes null).
  if (!date || Number.isNaN(date.valueOf())) {
    return;
  }

  // Now that we know the date is valid, we can safely proceed.
  console.log("RatioWithDateSelect handleDateChange-" + date);
  setSelectedDate(date);
  // Update the ref synchronously so a same-tick onClose/onBlur (closeOnSelect
  // after the minutes view) propagates THIS value, not a stale one.
  selectedDateRef.current = date;
};

  // useEffect(() => {
  //   props.onChange({
  //     target: {
  //       name: props.name,
  //       value: selectedDate,
  //     }
  //   });
  // }, [selectedDate]);

  

  const handleOnClose = () => {
    // Read from the ref (not the render closure) so the value picked in the
    // minutes view — which closes the picker in the same tick — is the one we
    // propagate.
    console.log("========================RatioWithDateSelect handleOnClose-" + selectedDateRef.current);
    props.onChange({
      target: {
        name: props.name,
        value: selectedDateRef.current,
      }
    });
  };

  const handleBlur = () => {
    console.log("========================RatioWithDateSelect handleBlur-" + selectedDateRef.current);
    props.onChange({
      target: {
        name: props.name,
        value: selectedDateRef.current,
      }
    });
  };

  return (
    <div>
      <Typography variant = 'h6' color="primary">{props.header}</Typography>
      <RadioGroup value={value} onChange={handleChange} style={styles.radio}>
        <FormControlLabel
          value="optionOne"
          control={<Radio color='primary' tabIndex={props.tabIndex || 0}/>}
          label={props.optionOne}
        />
        <FormControlLabel
          value="optionTwo"
          control={<Radio color='primary' tabIndex={props.tabIndex || 0}/>}
          label={props.optionTwo}
        />
      </RadioGroup>

      {value === 'optionTwo' &&
        <div className="animate__animated animate__fadeInUp">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Grid container justifyContent="left">
          <DateTimePicker
            ampm={false}
            timeSteps={{ minutes: 15 }}
            value={selectedDate ? dayjs(selectedDate) : null}
            onChange={(date) => handleDateChange(date ? date.toDate() : null)}
            onClose={handleOnClose}
            openTo="hours"
            disablePast
            format="YYYY-MM-DD HH:mm"
            slotProps={{
              textField: {
                size: 'small',
                style: styles.dateTimePicker,
                onBlur: handleBlur,
                tabIndex: props.tabIndex || 0,
              },
            }}
          />
          </Grid>
        </LocalizationProvider>
        </div>
      }
    </div>
  );
}

export default RatioWithDateSelect;
